import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tab-console" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  key: 0,
  class: "empty-data"
}
const _hoisted_5 = { class: "accessory-add" }
const _hoisted_6 = { class: "accessory-search" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "onChange", "checked"]

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";
import trim from "lodash-es/trim";

import { toast } from "@/common/utils/toast";
import { getDate, getHour } from "@/common/utils/dates";

import {
  consoleAccessoryList,
  consoleAccessoryListId,
  consoleAccessoryCreate,
  consoleAccessoryDelete,
} from "@/common/api/rest/console/accessory";

import { accessoryList } from "@/common/api/rest/accessory/accessory";

import type { ConsoleAccessoryType } from "@/common/types/console/accessory";
import type { AccessoryType } from "@/common/types/accessory/accessory";

import {
  baseAvatar,
  baseConfirm,
  baseLoading,
  baseInput,
  baseModal,
  baseSearchExact,
  baseTable,
  svgIcon,
} from "@/common/components";

const imageSize = "15rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'accessory',
  props: {
    consoleId: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v28417dcb": (imageSize)
}))

const { t, locale } = useI18n();

const props = __props;

const accessories = ref<ConsoleAccessoryType[]>([]);
const accessoryIds = ref<{ item_id: string; accessory_id: string }[]>([]);
const selected = ref<ConsoleAccessoryType | null>(null);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const loading = ref(true);
const showModalAddGame = ref(false);
const showModalRemoveGame = ref(false);

const accessorySearchListRef = ref<any>(null);
const accessorySearch = ref<string>("");
const accessoryExactSearch = ref<boolean>(false);
const accessorySearchList = ref<AccessoryType[]>([]);
const accessoryLimit = ref<number>(10);
const accessoryPage = ref<number>(0);
const accessoryPages = ref<number>(0);
const accessorySearched = ref<number>(0);
const accessoryTotal = ref<number>(0);
const loadingMoreAccessories = ref(false);

const tableHeader = computed(() => [
  { key: "avatar", label: "" },
  { key: "name", label: t("common.labels.name") },
  { key: "created", label: t("common.labels.created") },
]);

async function fetchAccessories() {
  await consoleAccessoryList(props.consoleId, {
    page: page.value,
    limit: limit.value,
    search: search.value,
    sort: "DESC",
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        accessories.value = data.list;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchAccessoryId() {
  await consoleAccessoryListId(props.consoleId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        accessoryIds.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function searchAccessories(append = false) {
  if (
    append &&
    (loadingMoreAccessories.value ||
      accessoryPage.value + 1 >= accessoryPages.value)
  ) {
    return;
  }

  if (append) {
    loadingMoreAccessories.value = true;
  }

  const pageToFetch = append ? accessoryPage.value + 1 : 0;

  await accessoryList({
    page: pageToFetch,
    limit: accessoryLimit.value,
    search: accessorySearch.value,
    match: accessoryExactSearch.value ? "exact" : "like",
    sort: "ASC",
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        const newItems = data.list ?? [];
        accessorySearchList.value = append
          ? [...accessorySearchList.value, ...newItems]
          : newItems;
        accessoryPage.value = pageToFetch;
        accessoryPages.value = data.infos.pages;
        accessoryTotal.value = data.infos.total;
        accessorySearched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loadingMoreAccessories.value = false;
    });
}

function changePage(value: number) {
  page.value = value;
  fetchAccessories();
}

function searchItem(value: string) {
  search.value = value;

  fetchAccessories();
}

function resetSearchAccessory() {
  accessorySearch.value = "";
  accessoryExactSearch.value = false;
  accessorySearchList.value = [];
  accessoryPage.value = 0;
  accessoryPages.value = 0;
  accessorySearched.value = 0;
  accessoryTotal.value = 0;
  loadingMoreAccessories.value = false;
}

async function addAccessory() {
  store.commit("SET_LOADING", true);

  resetSearchAccessory();
  await searchAccessories();
  store.commit("SET_LOADING", false);

  showModalAddGame.value = true;
}

async function searchAccessory() {
  accessorySearchList.value = [];
  accessoryPage.value = 0;
  accessoryPages.value = 0;
  accessorySearched.value = 0;
  accessoryTotal.value = 0;

  await searchAccessories();
}

function onAccessoryListScroll(event: Event) {
  const target =
    (event.target as HTMLElement | null) ?? accessorySearchListRef.value;

  if (!target) {
    return;
  }

  const reachedEnd =
    target.scrollTop + target.clientHeight >= target.scrollHeight - 24;

  if (
    reachedEnd &&
    !loadingMoreAccessories.value &&
    accessoryPage.value + 1 < accessoryPages.value
  ) {
    void searchAccessories(true);
  }
}

async function selectAccessory(accessory: AccessoryType) {
  if (
    !accessoryIds.value.some((a) => a.accessory_id === accessory.accessory_id)
  ) {
    await consoleAccessoryCreate(props.consoleId, {
      accessory_id: accessory.accessory_id,
    })
      .then((response) => {
        const { success, message } = response;

        if (success) {
          fetchAccessoryId();
          fetchAccessories();
        } else {
          toast({ message: message, type: "error" });
        }
      })
      .catch(() => {
        toast({ message: t("error.default"), type: "error" });
      });
  } else {
    const item = accessoryIds.value.find(
      (a) => a.accessory_id === accessory.accessory_id,
    );

    await consoleAccessoryDelete(item.item_id)
      .then((response) => {
        const { success, message } = response;

        if (success) {
          fetchAccessoryId();
          fetchAccessories();
        } else {
          toast({ message: message, type: "error" });
        }
      })
      .catch(() => {
        toast({ message: t("error.default"), type: "error" });
      });
  }
}

function removeAccessory(accessory: ConsoleAccessoryType) {
  selected.value = accessory;
  showModalRemoveGame.value = true;
}

function removeAccessoryCancel() {
  selected.value = null;
  showModalRemoveGame.value = false;
}

async function removeAccessoryConfirm() {
  if (!selected.value) {
    return;
  }

  await consoleAccessoryDelete(selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchAccessoryId();
        fetchAccessories();
        showModalRemoveGame.value = false;
        selected.value = null;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => accessorySearch.value,
  () => {
    if (trim(accessorySearch.value).length === 0) {
      searchAccessory();
    }
  },
);

watch(
  () => accessoryExactSearch.value,
  () => {
    if (trim(accessorySearch.value).length > 0) {
      searchAccessory();
    }
  },
);

onMounted(async () => {
  await fetchAccessories();
  await fetchAccessoryId();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(svgIcon), {
          icon: "no-image",
          size: "2rem"
        }),
        _createTextVNode(" " + _toDisplayString(_unref(t)("collection.labels.accessories")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(baseLoading))
            ]))
          : (_openBlock(), _createBlock(_unref(baseTable), {
              key: 1,
              header: tableHeader.value,
              data: accessories.value,
              limit: limit.value,
              page: page.value,
              pages: pages.value,
              total: total.value,
              searched: searched.value,
              options: true,
              copy: false,
              edit: false,
              del: true,
              "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
              onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
              "onBtn:add": addAccessory,
              "onBtn:del": _cache[2] || (_cache[2] = ($event: any) => (removeAccessory($event)))
            }, {
              avatar: _withCtx(({ data }) => [
                _createVNode(_unref(baseAvatar), {
                  position: "center",
                  "is-edit": false,
                  "show-image": true,
                  url: data?.avatar?.large,
                  "aspect-ratio": 1.333,
                  size: "3rem",
                  "border-radius": "0.25rem"
                }, null, 8, ["url"])
              ]),
              created: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(getDate)(data.created)) + " - " + _toDisplayString(_unref(getHour)(data.created)), 1)
              ]),
              _: 1
            }, 8, ["header", "data", "limit", "page", "pages", "total", "searched"]))
      ])
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalRemoveGame.value,
      title: _unref(t)('collection.modals.titles.del_game').toUpperCase(),
      message: 
      _unref(t)('collection.modals.messages.del_game', {
        name: selected.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (removeAccessoryCancel())),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (removeAccessoryConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseModal), {
      show: showModalAddGame.value,
      title: _unref(t)('collection.modals.titles.add_accessory').toUpperCase(),
      onClose: _cache[9] || (_cache[9] = ($event: any) => (showModalAddGame.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(baseInput), {
              modelValue: accessorySearch.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((accessorySearch).value = $event)),
              background: "#fff",
              color: "#000",
              placeholder: _unref(t)('common.labels.search'),
              "onKey:enter": _cache[7] || (_cache[7] = ($event: any) => (searchAccessory()))
            }, {
              sufix: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(svgIcon), {
                    icon: "search",
                    size: "1.75rem",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (searchAccessory()))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createVNode(_unref(baseSearchExact), {
            modelValue: accessoryExactSearch.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((accessoryExactSearch).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            ref_key: "accessorySearchListRef",
            ref: accessorySearchListRef,
            class: "accessory-list",
            onScroll: onAccessoryListScroll
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessorySearchList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "accessory"
              }, [
                _createVNode(_unref(baseAvatar), {
                  position: "center",
                  "is-edit": false,
                  "show-image": true,
                  url: item?.avatar?.large,
                  "aspect-ratio": 1.333,
                  size: "3rem",
                  "border-radius": "0.25rem"
                }, null, 8, ["url"]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                _createElementVNode("label", {
                  class: "custom-checkbox",
                  for: `accessory-${item.accessory_id}`
                }, [
                  _createElementVNode("input", {
                    id: `accessory-${item.accessory_id}`,
                    class: "checkbox-input",
                    type: "checkbox",
                    onChange: ($event: any) => (selectAccessory(item)),
                    checked: 
                    accessoryIds.value.some(
                      (a) => a.accessory_id === item.accessory_id,
                    )
                  
                  }, null, 40, _hoisted_10),
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "checkbox-mark" }, null, -1))
                ], 8, _hoisted_9)
              ]))
            }), 128))
          ], 544)
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})